import { PropsWithChildren } from 'react';
import clsx from 'clsx';
import Loader from './Loader';

type MetricDisplayProps = {
  title?: string;
  subTitle?: string;
  value?: number;
  subText?: string;
  childPosition?: 'right' | 'bottom';
  containerClassName?: string;
  isValueLoading?: boolean;
  navigateToList?: () => void;
};

const MetricDisplay = ({
  title,
  subTitle,
  value,
  subText,
  childPosition = 'right',
  containerClassName = '',
  isValueLoading,
  children,
  navigateToList,
}: PropsWithChildren<MetricDisplayProps>) => {
  return (
    <div
      onClick={navigateToList ? navigateToList : undefined}
      className={clsx(
        `flex rounded-md border border-gray-200 bg-white shadow-2xs p-6 gap-6 ${containerClassName}`,
        {
          'flex-col': childPosition === 'bottom',
          'flex-row': childPosition === 'right',
          'hover:cursor-pointer': navigateToList !== undefined,
        },
      )}
    >
      <div className="flex flex-col items-start gap-2">
        {title && (
          <h2 className="grow shrink basis-0 text-[#0c111d] text-lg font-semibold font-['Geist'] leading-normal">
            {title}
          </h2>
        )}
        {subTitle && (
          <h3 className="grow shrink basis-0 text-slate-600 text-sm font-medium font-['Geist'] uppercase leading-normal">
            {subTitle}
          </h3>
        )}
        {(value !== undefined || isValueLoading) &&
          (isValueLoading ? (
            <Loader />
          ) : (
            <p className="text-[#0c111d] text-2xl font-semibold font-['Geist'] leading-7">
              {value}
            </p>
          ))}
        {subText && (
          <p className="text-slate-600 text-xs font-normal font-['Geist'] leading-none">
            {subText}
          </p>
        )}
      </div>
      {children}
    </div>
  );
};

export default MetricDisplay;
